import { Injector } from "@angular/core";
import { ServiceEnum } from "../../../ServiceEnum";
import { ScientificProductsEntity } from "../../../Data/MedicinalProductData/ScientificProductsEntity";
import { AutoUploadList } from "../ListEntity/AutoUploadList";
import { EntityEnum } from "../../EntityEnum";
import { AbstractStrenghtsAutoUploadEntity } from "./AbstractStrenghtsAutoUploadEntity";
import { AbstractFormulationsAutoUploadEntity } from "./AbstractFormulationsAutoUploadEntity";
import { DummyNode } from "../../DummyNode";
import { OnDemandAutoUploadList } from "../ListEntity/OnDemandAutouploadList";
import { OnDemandAutoUploadNode } from "../OnDemandAutoUploadNode";


export class AbstractFormulationsAutoUploadList extends OnDemandAutoUploadList {
    useHist: boolean = false;
    constructor(injector: Injector, labelTemplate: string, searchCriteriaId: string, useHist: boolean, disableAutoupload: boolean, cloningNode: boolean ) {
        super(injector, 
            labelTemplate,
            ['Scientific Name','Scientific Code','Scientific Strength','Scientific Pharmaceutical Form Name','Owner HQ ID','Type', 'Status', 'Nullified'],
            ServiceEnum.MedicinalProducts,
            `prodform:eq:${searchCriteriaId}`,
            ScientificProductsEntity,
            EntityEnum.abstractFormulations,
            disableAutoupload,
            cloningNode
            );
            this.useHist = useHist;
            
            if (this.cloningNode) {
                return;
             }

             this.children?.push(new DummyNode());
    }

    override postLoad(model: any[]) {
        model.forEach((item:any) => {
            this.children?.push(new AbstractFormulationsAutoUploadEntity(this.ioc!, `${item.scientificname}`,this,this.useHist,true, false,item));            
        });

        const numItems: string = model && model.length > 0?model.length.toString():'0'; 
        this.label = this.labelTemplate + ' (' + numItems + ')';
        this.refreshLabel();
    }

    override getOnDemandEntities() { 
        if (!this.isLoaded) {
            return {};
        }
        const entitiesArray:any[] = [];
        this.children?.forEach(child=>{
            const onDemandEntities: any = (child as OnDemandAutoUploadNode).getOnDemandEntities();
            entitiesArray.push(onDemandEntities);
        });
        return {abstractformulations: {abstractformulation: entitiesArray}};
    }

}